module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921082649_T.00bc32c0.jpg";